import { formatRupiah } from "@/helpers/utils";
import dayjs from "dayjs";
import { _ } from "gridjs-react";

const translateAccountType = (type) => {
  const translations = {
    'ASSET': 'Aset',
    'LIABILITY': 'Kewajiban',
    'EQUITY': 'Modal',
    'REVENUE': 'Pendapatan',
    'EXPENSE': 'Beban',
    'COGS': 'Harga Pokok Penjualan'
  };
  return translations[type?.toUpperCase()] || type;
};

const translateAccountGroup = (group) => {
  const translations = {
    'CURRENT_ASSET': 'Harta Lancar',
    'FIXED_ASSET': 'Harta Tetap',
    'OTHER_ASSET': 'Harta Lainnya',
    'CURRENT_LIABILITY': 'Hutang Lancar',
    'LONG_TERM_LIABILITY': 'Hutang Jangka Panjang',
    'MEMBER_EQUITY': 'Modal Anggota',
    'RETAINED_EARNINGS': 'Laba Ditahan',
    'OPERATING_REVENUE': 'Pendapatan Operasional',
    'NON_OPERATING_REVENUE': 'Pendapatan Non-Operasional',
    'OPERATING_EXPENSE': 'Beban Operasional',
    'NON_OPERATING_EXPENSE': 'Beban Non-Operasional',
    'COST_OF_GOODS_SOLD': 'Harga Pokok Penjualan'
  };
  return translations[group?.toUpperCase()] || group;
};

export const getColumnsData = (onEdit, onDelete) => [
  {
    name: 'Kode COA',
    data: (row) => row.account_code,
  },
  {
    name: 'Nama COA',
    data: (row) => row.account_name,
  },
  {
    name: 'Urutan',
    data: (row) => row.level,
  },
  {
    name: 'Posisi Debit/Kredit',
    data: (row) => row.normal_balance,
  },
  {
    name: 'Kelompok',
    data: (row) => translateAccountGroup(row.account_group),
  },
  {
    name: 'Kategori',
    data: (row) => translateAccountType(row.account_type),
  },
  {
    name: 'Saldo Awal',
    data: (row) => formatRupiah(row.opening_balance),
  },
  {
    name: 'Aksi',
    width: '120px',
    data: (row) => row,
    formatter: (row) => {
      return _(
        <div className="flex gap-2 justify-center">
          <button
            className="btn btn-sm bg-warning text-white hover:bg-yellow-600 px-3 py-1 rounded"
            onClick={() => onEdit(row)}
            title="Edit"
          >
            <i className="mgc_edit_line"></i>
          </button>
          <button
            className="btn btn-sm bg-danger text-white hover:bg-red-700 px-3 py-1 rounded"
            onClick={() => onDelete(row)}
            title="Delete"
          >
            <i className="mgc_delete_line"></i>
          </button>
        </div>
      );
    }
  }
];

// Keep the old export for backward compatibility
export const columnsData = [
  {
    name: 'Kode COA',
    data: (row) => row.account_code,
  },
  {
    name: 'Nama COA',
    data: (row) => row.account_name,
  },
  {
    name: 'Urutan',
    data: (row) => row.level,
  },
  {
    name: 'Posisi Debit/Kredit',
    data: (row) => row.normal_balance,
  },
  {
    name: 'Kelompok',
    data: (row) => translateAccountGroup(row.account_group),
  },
  {
    name: 'Kategori',
    data: (row) => translateAccountType(row.account_type),
  },
  {
    name: 'Saldo Awal',
    data: (row) => formatRupiah(row.opening_balance),
  },
];
